import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ButtonCustom from '../atoms/button/ButtonCustom.jsx'
import CommonModal from '../atoms/modal/CommonModal.jsx'
import { closeModal, setModalData } from '../../features/commonSlice.js'
import InputCustom from '../atoms/input/InputCustom.jsx'
import {
	getKazooProposals,
	updateProposal,
} from '../../features/proposalSlice.js'

export const RemoveProposalPopup = ({ kazooId }) => {
	const [reason, setReason] = useState('')
	const dispatch = useDispatch()
	const modal = useSelector((s) => s.common.modal)
	const data = useSelector((s) => s.common.data)

	const closeModals = () => {
		dispatch(closeModal())
		dispatch(setModalData(null))
	}

	const handleRemove = () => {
		dispatch(
			updateProposal({
				proposalId: data,
				status: 'Deleted',
				reason,
			})
		).then(() => {
			dispatch(getKazooProposals(kazooId))
			closeModals()
		})
	}

	return (
		<CommonModal
			open={modal === 'removeProposal'}
			handleClose={closeModals}
			heading={'Are you sure?'}
			subHeading={'This action is permanent and cannot be undone.'}
			footerContent={
				<>
					<ButtonCustom
						variant="outlined"
						type="button"
						size="lg"
						onClick={closeModals}
					>
						Cancel
					</ButtonCustom>
					<ButtonCustom
						variant="destructive"
						size="lg"
						onClick={handleRemove}
					>
						Remove
					</ButtonCustom>
				</>
			}
		>
			<InputCustom
				value={reason}
				onChange={(e) => setReason(e.target.value)}
				type="text"
				placeholder="Please enter reason"
				sx={{
					'& .MuiFormHelperText-root': {
						position: 'absolute',
						bottom: '20px',
					},
				}}
			/>
		</CommonModal>
	)
}
